import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ensureLogin as globalEnsureLogin } from '@utils/globalEnsureLogin';
import { ensureBack } from '@utils/navigation';
import { disableConsole, restoreConsole } from '@utils/disableConsole';
import { initSensors } from '@utils/sensors';

// 将 globalEnsureLogin 挂载到全局对象上
window.globalEnsureLogin = globalEnsureLogin;
window.ensureBack = ensureBack;

// 开发和测试环境保留 console，生产及其他未知环境默认禁用日志
// build:staging 使用 production 作为 NODE_ENV，因此同时通过测试站点地址识别测试环境
const isLocalDevHost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');
const canPrintConsole =
  isLocalDevHost ||
  (typeof process !== 'undefined' &&
    process.env &&
    (process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'test' ||
      process.env.REACT_APP_SITE_ORIGIN === 'https://club-test.vivo.com.cn'));
if (!canPrintConsole) {
  disableConsole({ onlyInProduction: false });
} else {
  // 热更新前若曾禁用过 console，进入开发或测试环境时恢复原始方法
  restoreConsole();
}



// 设置 REM 基准值 - 修改这部分代码
(function setRem() {
  const baseSize = 100;
  const designWidth = 750;

  function setRemUnit() {
    const clientWidth = document.documentElement.clientWidth;
    // 只在移动端设置 rem，PC 端不处理
    if (clientWidth <= 768) {
      // 限制最大宽度为设计稿宽度 750，防止超大屏rem过大
      const width = Math.min(clientWidth, 750);
      const fontSize = (width / designWidth) * baseSize;
      document.documentElement.style.fontSize = fontSize + 'px';
    } else {
      // PC 端恢复默认
      document.documentElement.style.fontSize = '';
    }
  }

  setRemUnit();
  window.addEventListener('resize', setRemUnit);
})();

initSensors();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

reportWebVitals();
